module.exports = __webpack_public_path__ + "img/hong_kong_2016.147eb08f.png";